import React from "react";

const About = () => {
  return (
    <section className="section-shell bg-secondery px-5 py-20 text-white md:px-8" id="about">
      <div className="mx-auto w-full max-w-6xl">
        <div className="reveal-up reveal-delay-1 mb-8 text-left">
          <p className="section-kicker mb-3">About</p>
          <h2 className="heading-font section-title text-3xl font-bold sm:text-4xl">Engineering with security and scale in mind</h2>
        </div>

        <div className="glass-panel reveal-up reveal-delay-2 grid gap-6 rounded-3xl p-6 md:p-9">
          <ul className="grid list-disc gap-3 pl-5 text-slate-300 md:grid-cols-2 md:gap-x-10">
            <li>Cloud Infrastructure Engineer focused on AWS and Azure.</li>
            <li>Specialized in cloud security, platform engineering, and DevOps.</li>
            <li>Master of Information Technology (Cyber Security), University of Melbourne.</li>
            <li>AWS Certified Solutions Architect - Associate.</li>
            <li>Hands-on with Terraform, GitHub Actions, Ansible, and cloud-native automation.</li>
            <li>Driven by practical, secure, and scalable business outcomes.</li>
          </ul>

          <div className="grid gap-4 sm:grid-cols-3">
            <div className="rounded-2xl border border-slate-500/25 bg-slate-900/35 p-4">
              <p className="text-xs font-bold uppercase tracking-[0.14em] text-teal-300">Cloud</p>
              <p className="mt-2 text-sm text-slate-200">Architecture, operations, and governance.</p>
            </div>
            <div className="rounded-2xl border border-slate-500/25 bg-slate-900/35 p-4">
              <p className="text-xs font-bold uppercase tracking-[0.14em] text-teal-300">Security</p>
              <p className="mt-2 text-sm text-slate-200">Hardening, posture improvement, and risk reduction.</p>
            </div>
            <div className="rounded-2xl border border-slate-500/25 bg-slate-900/35 p-4">
              <p className="text-xs font-bold uppercase tracking-[0.14em] text-teal-300">Delivery</p>
              <p className="mt-2 text-sm text-slate-200">IaC and CI/CD for reliable platform delivery.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
